import { Injectable, inject } from '@angular/core';

import { Observable, map } from 'rxjs';

import { environment } from '../../../environments/environment';
import { withAllTenants } from '../interceptors/tenant.interceptor';
import { GraphqlService } from './graphql.service';
import { Client } from '../interfaces';

interface ClientSimpleListResponse {
  clients: {
    items: readonly ClientApiItem[];
  };
}

interface ClientApiItem {
  uuid: string;
  name: string;
  logo?: string | null;
}

@Injectable({ providedIn: 'root' })
export class ClientService {
  private readonly graphql = inject(GraphqlService);

  getMyClients(): Observable<readonly Client[]> {
    const query = `
      query client_simple_list($q: ClientQueryInput) {
        clients(q: $q) {
          items {
            uuid
            name
            logo
          }
        }
      }
    `;

    const variables = {
      q: {
        forClientUser: true,
        sort: [{ by: 'NAME' }],
        limit: 1000,
      },
    };

    return this.graphql
      .query<ClientSimpleListResponse>(query, variables, 'client_simple_list', withAllTenants())
      .pipe(map((data) => data.clients.items.map((item) => mapClient(item))));
  }
}

function mapClient(item: ClientApiItem): Client {
  return {
    uuid: item.uuid,
    name: item.name,
    logo: item.logo ? `${environment.storageBaseUrl}${item.logo}` : null,
  };
}
